
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useLiveopsTranslation } from '@/modules/liveops/item/model/translate';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';

export default defineComponent({
    name: 'LiveopsTranslation',
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = useLiveopsTranslation();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions, ROUTE_NAME_LIVEOPS };
    }
});
